import { BreakfastIncludeIcon, DinnerOnlyIcon, BreakfastIncludeDinnerOnlyIcon, NoMealIcon } from '@/components/Icons';
import { BoardType } from '@/constants';
import React from 'react';

type Props = { boardTypes: string[]; additionalIcon?: React.ReactElement };

export default function BoardTypeList({ boardTypes, additionalIcon }: Props) {
  return (
    <>
      {boardTypes.map(type => {
        if (type === BoardType.__getValue(BoardType.BreakfastIncl)) {
          return <BreakfastIncludeIcon key={BoardType.__getValue(BoardType.BreakfastIncl)} additionalIcon={additionalIcon} />;
        }
        if (type === BoardType.__getValue(BoardType.DinnerOnly)) {
          return <DinnerOnlyIcon key={BoardType.__getValue(BoardType.DinnerOnly)} additionalIcon={additionalIcon} />;
        }
        if (type === BoardType.__getValue(BoardType.DinnerAndBreakfastIncl)) {
          return <BreakfastIncludeDinnerOnlyIcon key={BoardType.__getValue(BoardType.DinnerAndBreakfastIncl)} additionalIcon={additionalIcon} />;
        }
        return <NoMealIcon key={BoardType.__getValue(BoardType.NoMeals)} additionalIcon={additionalIcon} />;
      })}
    </>
  );
}
